import { Alert, CustomProffixService, HelpersService, UserSessionService, StundenAntrag } from '../services';

export class BaseComponent {
  public alerts: Array<Alert> = [];

  public closeAlert(alert: Alert) {
    const index: number = this.alerts.indexOf(alert);
    this.alerts.splice(index, 1);
  }
  public addSuccessAlert(msg: string): void {
    this.addAlert(msg, 'success');
  }
  public addInfoAlert(msg: string): void {
    this.addAlert(msg, 'info');
  }
  public addWarningAlert(msg: string): void {
    this.addAlert(msg, 'warning');
  }
  public addDangerAlert(msg: string): void {
    this.addAlert(msg, 'danger');
  }
  public addPrimaryAlert(msg: string): void {
    this.addAlert(msg, 'primary');
  }
  public addSecondaryAlert(msg: string): void {
    this.addAlert(msg, 'secondary');
  }
  public addLightAlert(msg: string): void {
    this.addAlert(msg, 'light');
  }
  public addDarkAlert(msg: string): void {
    this.addAlert(msg, 'dark');
  }

  private addAlert(msg: string, type: string) {
    this.alerts.push(
      {
        Id: 1,
        Type: type,
        Message: msg,
      });
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/base.component.ts